// extracted by mini-css-extract-plugin
export default {"quote":"quote_quote__NvTEY","bottom":"quote_bottom__T7Msy"};